import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { useDisposes } from '@/composables/use-disposes';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PatentsListService } from '../service/patents-list.service';
import type { Patent } from '../type/patents-list.type';

export const usePatentsList = createGlobalState(() => {
    const patentsListService = injectService<PatentsListService>(PatentsListService);

    const { disposes } = useDisposes();

    const selectedPatentList = ref(patentsListService.selectedList);
    disposes.push(patentsListService.onSelectedChange(list => {
        selectedPatentList.value = list;
    }));

    function setSelectedPatent(patent: Patent) {
        patentsListService.setSelected(patent);
    }

    const isShowPatentList = ref(patentsListService.isShowList);
    disposes.push(patentsListService.onListVisibleChange(value => {
        isShowPatentList.value = value;
    }));

    function setPatentListVisible(value: boolean) {
        patentsListService.setListVisible(value);
    }

    const idList = ref(patentsListService.idList);
    disposes.push(patentsListService.onIdListChange(list => {
        idList.value = list;
    }));

    function setIdList(value: string[]) {
        patentsListService.setIdList(value);
    }

    return {
        selectedPatentList,
        setSelectedPatent,
        isShowPatentList,
        setPatentListVisible,
        idList,
        setIdList,
    }
});
